import React from 'react';
import { Settings } from 'lucide-react';
import { useAuthStore } from '../../../stores/auth-store';
import { useUpdateExternalUser } from '../../../hooks/users/useExternalUsers';

export const ProfilePreferencesCard: React.FC = () => {
  const { currentUser, updateCurrentUser } = useAuthStore();
  const updateUserMutation = useUpdateExternalUser();

  const handleToggleTutorials = async () => {
    if (!currentUser?.id) return;

    const newValue = !currentUser.showTutorials;

    try {
      await updateUserMutation.mutateAsync({
        id: currentUser.id,
        data: {
          showTutorials: newValue,
        },
      });

      updateCurrentUser({
        showTutorials: newValue,
      });
    } catch (error) {
      console.error('Erreur lors de la mise à jour des préférences:', error);
    }
  };

  return (
    <div className="tw-bg-white tw-rounded-lg tw-shadow-sm tw-border tw-border-gray-200 tw-p-6">
      <div className="tw-flex tw-items-center tw-gap-2 tw-mb-6">
        <Settings className="tw-w-5 tw-h-5 tw-text-affinicar-primary" />
        <h2 className="tw-text-lg tw-font-semibold tw-text-gray-900">
          Préférences
        </h2>
      </div>

      <div className="tw-flex tw-items-center tw-justify-between tw-py-3">
        <div>
          <p className="tw-text-sm tw-font-medium tw-text-gray-900">
            Afficher les tutoriels
          </p>
          <p className="tw-text-xs tw-text-gray-500 tw-mt-0.5">
            Activer ou désactiver les guides d'aide à la navigation
          </p>
        </div>

        <button
          onClick={handleToggleTutorials}
          disabled={updateUserMutation.isLoading}
          className={`tw-relative tw-inline-flex tw-h-6 tw-w-11 tw-items-center tw-rounded-full tw-transition-colors focus:tw-outline-none focus:tw-ring-2 focus:tw-ring-affinicar-primary focus:tw-ring-offset-2 ${
            currentUser?.showTutorials
              ? 'tw-bg-affinicar-primary'
              : 'tw-bg-gray-200'
          } ${updateUserMutation.isLoading ? 'tw-opacity-50 tw-cursor-not-allowed' : ''}`}
        >
          <span
            className={`tw-inline-block tw-h-4 tw-w-4 tw-transform tw-rounded-full tw-bg-white tw-transition-transform ${
              currentUser?.showTutorials ? 'tw-translate-x-6' : 'tw-translate-x-1'
            }`}
          />
        </button>
      </div>
    </div>
  );
};
